// extracted by mini-css-extract-plugin
export var productImage = "_zg-0";